module.exports = __webpack_public_path__ + "static/media/icons_Bilan découverte - membres inférieurs.d148d253.svg";